/**
 * Import from node_modules
 */
import 'bootstrap/js/src/scrollspy';

/**
 * Import site scripts
 */
import SkipLinkFocusFix from './site/skip-link-focus-fix';
import Menu from './site/menu';
import Sliders from './site/sliders';
import ScrollTo from './site/scrollTo';
import Styleguide from './site/styleguide';
import Fancybox from './site/fancybox';
import Select2 from './site/select2';
import FormHelpers from './site/formHelpers';
import PerfectScroll from './site/perfectScroll';
import LazyLoading from './site/lazyLoad';
import LoadMoreBlog from './site/loadMoreBlog';
import Header from './site/header';
import inputForms from './site/inputForms';
import FormLabel from './site/formLabel';
import EqualHeights from './site/equalHeights';
import Video from './site/video';
import Tabs from './site/tabs';
import Count from './site/count-animation';
import AOS from 'aos';
import LoginUser from './site/loginUser';
import AutocompleteCity from './site/autocompleteCity';
import QuoteDetails from './site/quoteDetails';
import ActiveResources from './site/activeResources';
import mediaVids from './site/mediaVids';
import Accordion from './site/accordion';
/**
 * Init site scripts
 */
jQuery(function() {
	SkipLinkFocusFix.init();
	Styleguide.init();
	Menu.init();
	Sliders.init();
	ScrollTo.init();
	Fancybox.init();
	Select2.init();
	FormHelpers.init();
	PerfectScroll.init();
	LazyLoading.init();
	LoadMoreBlog.init();
	Header.init();
	inputForms.init();
	FormLabel.init();
	EqualHeights.init();
	Video.init();
	Tabs.init();
	Count.init();
	AOS.init({
		once: true,
	});
	LoginUser.init();
	AutocompleteCity.init();
	QuoteDetails.init();
	ActiveResources.init();
	mediaVids.init();
	Accordion.init();
});
